import { FC, MouseEventHandler, useCallback, useEffect, useState } from "react";
import "./CopyToClipboard.scss";
import useCopyToClipboard from "../../hooks/useCopyToClipboard";
import ImgCopy from "./Img/copy_sprite.svg"
import ImageSprite from "../ImageSprite/ImageSprite";
export interface styleType { type: "link" }

interface Props {
    text: string;
    style?: styleType,
    data?: Array<string>
}

const CopyToClipboard: FC<Props> = ({ text, style, data }) => {
    const prepareToCopy: string | undefined = data?.join("\n");

    const [inputText, setNewText] = useState(text);
    const [inputData, setNewData] = useState(prepareToCopy);

    const [copyToClipboard, copyResult] = useCopyToClipboard();

    const handleClickCopy = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        event.stopPropagation();
        copyToClipboard(inputData ?? text);
    }, [text]);

    useEffect(() => {
        setNewText(text)
        setNewData(prepareToCopy)
    }, [text, prepareToCopy, data])

    return (
        <button type="button" style-type={style?.type} className="copy_to_clipboard" onClick={handleClickCopy}>
            <div className="copy_to_clipboard__text">{inputText}</div>
            <div className="copy_to_clipboard__img">
                <ImageSprite iconSprite={`${ImgCopy}#copy`} />
            </div>

            <div className="copy_to_clipboard__message">
                <span className="copy_to_clipboard__message_success">
                    {copyResult?.state === "success" && "Copied successfully!"}
                </span>
                <span className="copy_to_clipboard__message_error">
                    {copyResult?.state === "error" && `Error: ${copyResult.message}`}
                </span>
            </div>
        </button>
    );
};

export default CopyToClipboard;